import React from 'react'
import { useEffect as UseEffect } from "react";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';

const index = ({ group, nameGroup, itemField, value, className, disabled, id, name, onChange, help, design, classNameNoWrap }) => {


  UseEffect(() => {
    if (group && nameGroup && itemField.idFieldTable === 'isDefault') {
      if (group[nameGroup].length === 1 && (nameGroup.split('_')[2] === 'Domicilio' || nameGroup.split('_')[2] === 'Fiscal')) {
        onChange(null, true);
      }
    }
  }, []);

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Tooltip title={help} placement="top">
      <FormGroup className={className ?? undefined}>
        <FormControlLabel key={id}
          className={classNameNoWrap} sx={{
            textWrap: classNameNoWrap === 'noWrap'
              ? 'nowrap !important'
              : undefined
          }}
          control={<Switch checked={value} id={id}
          />}
          disabled={disabled}
          label={
            <span style={{ fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" }}>{design !== 'table' ? name : null}</span>
          }
          value={value}
          onChange={handleChange}
        />
      </FormGroup>
    </Tooltip>
  )
}

export default index